import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import MenusNav from '@base/MenusNav/MenusNav';
import { menus } from '@utils/constants';
import Layout from '@layout/index';
import LeftContainer from '@cont/CompanyDetails/LeftContainer';
import RightContainer from '@cont/CompanyDetails/RightContainer';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Right = styled(RightContainer)`
  height: calc(100vh - 354px);
`;

const RefundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: span 24;
`;

const RefundContainer = styled.div``;

const H2Container = styled.div``;

const RefundPolicy = () => {
  const router = useRouter();
  const { pathname } = router;

  return (
    <>
      <LeftContainer>
        <MenusNav data={menus} currentHref={pathname} />
      </LeftContainer>

      <Right>
        <RefundWrapper>
          <RefundContainer>
            <H2Container>
              <H2 as="h1">Refund Policy For Online Subscriptions</H2>
            </H2Container>
            <br />
            <div>
              <article>
                <P1>
                  Please read the subscription terms and conditions carefully
                  before subscribing to any of the subscription plans, as once
                  you have subscribed, you cannot change or cancel your
                  subscription plan. Once you subscribe and make the required
                  payment for any online subscriptions, it shall be final and
                  there cannot be any changes or modifications to the same and
                  neither will there be any refund.
                </P1>
              </article>
            </div>
            <br />
            <br />
          </RefundContainer>
        </RefundWrapper>
      </Right>
    </>
  );
};

RefundPolicy.pageInfo = {
  name: 'Unacademy Refund Policy',
  isMWebSupported: true,
  layoutOptions: {
    hideGoalSelector: true,
    disableDarkMode: true
  }
};

export default RefundPolicy;
RefundPolicy.Layout = Layout;
RefundPolicy.Wrapper = PageReduxProvider;
